import { Accordion, AccordionContent, AccordionHeader } from '@jouzen/ecom-components/v3/Accordion';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';

import { type BenefitsItem, benefitsList } from '../_data/benefitsList';

const CareersBenefits = () => {
  const t = useTranslations();

  return (
    <section data-cy="careers-benefits">
      <LayoutGrid rowGap={32}>
        <Typography
          className="col-main mb-8 lg:col-start-9 lg:col-end-main"
          Element="h3"
          height="tight"
          variant="h1"
          weight="light"
        >
          {t('whatever_you_need')}
        </Typography>

        <GridItem
          className="border-t-2 border-b border-sandstone-500"
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
        >
          <Accordion>
            <AccordionHeader>
              <div className="grid grid-cols-4 items-center py-8 md:w-4/5 md:grid-cols-8">
                <Image
                  className="col-start-1 col-end-3 row-start-1 hidden md:col-end-4 md:flex"
                  height={171}
                  localizedAlt="san_francisco"
                  src="careers/desktop_san-francisco"
                  width={305}
                />
                <Typography
                  className="col-start-1 col-end-5 row-start-1 flex md:col-start-4 md:col-end-9 md:pl-4"
                  Element="h4"
                  variant="h4"
                >
                  {t('san_francisco_and_san_diego')}
                </Typography>
              </div>
            </AccordionHeader>
            <AccordionContent>
              <div className="grid grid-cols-4 pb-12 md:w-4/5 md:grid-cols-8">
                <ul className="col-span-5 md:col-start-4">
                  {benefitsList.sanFrancisco.map(
                    ({ id, text }: BenefitsItem) => (
                      <Typography Element="li" className="py-2" key={id}>
                        {t(text)}
                      </Typography>
                    ),
                  )}
                </ul>
              </div>
            </AccordionContent>
            <AccordionHeader>
              <div className="grid grid-cols-4 items-center py-8 md:w-4/5 md:grid-cols-8">
                <Image
                  className="col-start-1 col-end-3 row-start-1 hidden md:col-end-4 md:flex"
                  height={171}
                  localizedAlt="helsinki_and_oulu"
                  src="careers/desktop_finland"
                  width={305}
                />
                <Typography
                  className="col-start-1 col-end-5 row-start-1 flex md:col-start-4 md:col-end-9 md:pl-4"
                  Element="h4"
                  variant="h4"
                >
                  {t('helsinki_and_oulu')}
                </Typography>
              </div>
            </AccordionHeader>
            <AccordionContent>
              <div className="grid grid-cols-4 pb-12 md:w-4/5 md:grid-cols-8">
                <ul className="col-span-5 md:col-start-4">
                  {benefitsList.helsinkiAndOulu.map(
                    ({ id, text }: BenefitsItem) => (
                      <Typography Element="li" className="py-2" key={id}>
                        {t(text)}
                      </Typography>
                    ),
                  )}
                </ul>
              </div>
            </AccordionContent>
          </Accordion>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default CareersBenefits;
